import { WbsListDto } from '@api/client';
import React from 'react';
import { useEffect } from 'react';

const useValidationWbs = ({
  totalForecastDeliverables,
  deliverablesTableData,
  setTotalDeliverablesValidation,
}: {
  totalForecastDeliverables: number[] | undefined;
  deliverablesTableData: WbsListDto[] | undefined;
  setTotalDeliverablesValidation: (value: boolean) => void;
}) => {
  const [areTotalsDeliverablesMatch, setAreTotalsDeliverablesMatch] = React.useState<boolean[]>();

  useEffect(() => {
    if (totalForecastDeliverables && totalForecastDeliverables.length > 0) {
      let validation = true;
      totalForecastDeliverables.forEach((el, index) => {
        if (
          el !==
          deliverablesTableData?.[index]?.wbsPlanningDtoList
            ?.filter((alloc) => alloc.enable)
            ?.reduce((acc, el) => acc + (el.corrispettivo ?? 0), 0)
        ) {
          validation = false;
        }
      });

      setTotalDeliverablesValidation(validation);

      setAreTotalsDeliverablesMatch(
        totalForecastDeliverables.map(
          (el, index) =>
            el ==
            deliverablesTableData?.[index]?.wbsPlanningDtoList
              ?.filter((alloc) => alloc.enable)
              ?.reduce((acc, el) => acc + (el.corrispettivo ?? 0), 0)
        )
      );
    }
  }, [totalForecastDeliverables]);

  const getTooltip = (index: number) => {
    const difference =
      totalForecastDeliverables?.[index]!! -
      (deliverablesTableData?.[index]?.wbsPlanningDtoList
        ?.filter((alloc) => alloc.enable)
        ?.reduce((acc, el) => acc + (el.corrispettivo ?? 0), 0) ?? 0);
    return `${difference > 0 ? '+' : ''}${Number(difference.toFixed(2))} €`;
  };

  return {
    areTotalsDeliverablesMatch,
    getTooltip,
  };
};

export default useValidationWbs;
